module.exports = __webpack_public_path__ + "static/3-3c9600cff4ff523297beec335f680093.webp";